@use "../../styles/mixins/component-wrapper" as wrapper;

@include wrapper.layered-component {
  p.hint {
    border: none; /* reset browser default borders */
    font: var(--semantic-text-utility-default-s);
    font-style: normal;
    letter-spacing: var(--semantic-letter-spacing-utility-s);

    /* STATE */
    &.resting {
      color: var(--semantic-color-on-surface-secondary-resting);
    }

    &.disabled {
      color: var(--semantic-color-on-surface-secondary-disabled, #ced0d8); // bug in tokens?
    }
  }
}
